import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const BulbIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <path
        d="M10 10.5V12C10 12.2652 9.89464 12.5196 9.70711 12.7071C9.51957 12.8946 9.26522 13 9 13H7C6.73478 13 6.48043 12.8946 6.29289 12.7071C6.10536 12.5196 6 12.2652 6 12V10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.94369 10.5H10.057C10.7999 10.1313 11.4234 9.56015 11.8557 8.85243C12.288 8.14471 12.5114 7.32923 12.5004 6.5C12.4793 5.31311 11.9984 4.18071 11.159 3.34132C10.3197 2.50192 9.18725 2.02106 8.00036 2C6.81301 2.02108 5.68023 2.50231 4.84076 3.34227C4.0013 4.18224 3.52073 5.31531 3.50036 6.50267C3.48978 7.33145 3.71351 8.14636 4.14578 8.85356C4.57805 9.56076 5.20128 10.1315 5.94369 10.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 13V14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8V10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 6.5L8 8L9.5 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
